import { Component } from "@angular/core";
import { AbstractModal } from "../../../../shared/models/abstract-modal";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-privacy-modal",
  templateUrl: "./privacy-modal.component.html",
  styleUrls: ["./privacy-modal.component.scss"],
})
export class PrivacyModalComponent extends AbstractModal {
  constructor(protected ngbActiveModal: NgbActiveModal) {
    super(ngbActiveModal);
  }
}
